import {z} from "zod/v4";

export enum ShapeType {
  CIRCLE = "CIRCLE",
  RECTANGLE = "RECTANGLE",
  ATTRACTOR = "ATTRACTOR",
}

// Zod schemas for enums
export const ShapeTypeSchema = z.enum(["CIRCLE", "RECTANGLE", "ATTRACTOR"]);

export enum GameObjectType {
  SPAWN = "spawn",
  SHARD = "shard",
  PLASTIC = "plastic",
  SAND = "sand",
  FIRE = "fire",
  ICE = "ice",
  ATTRACTOR = "attractor",
}

// Zod schemas for enums
export const GameObjectTypeSchema = z.nativeEnum(GameObjectType);

// ObjectTypeConfig schema
export const ObjectTypeConfigSchema = z.object({
  displayName: z.string(),
  description: z.string(),
  image: z.string(),
  shape: ShapeTypeSchema,
  shapeIndex: z.number(),
  limit: z.number(),
  zLevel: z.number(),
  scaleFactor: z.number().optional(),
  defaultScale: z.tuple([z.number(), z.number()]),
});

// LevelObject schema
export const LevelObjectSchema = z.object({
  type: GameObjectTypeSchema,
  position: z.tuple([z.number(), z.number()]),
  rotation: z.number(),
  scale: z.tuple([z.number(), z.number()]),
});
export const LevelObjectTransformSchema = LevelObjectSchema.omit({
  type: true,
});

// GlobalConstraints schema
export const GlobalConstraintsSchema = z.object({
  minPosition: z.tuple([z.number(), z.number()]),
  maxPosition: z.tuple([z.number(), z.number()]),
  minScale: z.tuple([z.number(), z.number()]),
  maxScale: z.tuple([z.number(), z.number()]),
});

// LevelConfig schema
const Keys = z.enum([
  "spawn",
  "shard",
  "plastic",
  "sand",
  "fire",
  "ice",
  "attractor",
]);
export const LevelConfigSchema = z.object({
  version: z.string(),
  globalConstraints: GlobalConstraintsSchema,
  objectTypes: z.record(Keys, ObjectTypeConfigSchema),
});

// Types inferred from the schemas (optional):
export type TObjectTypeConfig = z.infer<typeof ObjectTypeConfigSchema>;
export type TLevelObject = z.infer<typeof LevelObjectSchema>;
export type TLevelObjectTransform = z.infer<typeof LevelObjectTransformSchema>;
export type TGlobalConstraints = z.infer<typeof GlobalConstraintsSchema>;
export type TLevelConfig = z.infer<typeof LevelConfigSchema>;
